import { render, staticRenderFns } from "./TMTeamGeral.vue?vue&type=template&id=24137882&scoped=true"
import script from "./TMTeamGeral.vue?vue&type=script&lang=js"
export * from "./TMTeamGeral.vue?vue&type=script&lang=js"
import style0 from "./TMTeamGeral.vue?vue&type=style&index=0&id=24137882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24137882",
  null
  
)

export default component.exports